import { Dream, SparkelloImage } from 'sparkello-core';
import { DefaultPhotos } from 'sparkello-core';

export class WebDream extends Dream {
  public constructor(id = '', displayName = '') {
    super(id, displayName)
    this.image = SparkelloImage.parseRemoteUri(DefaultPhotos.getRandomDreamPhoto())
  }

  public clone(): WebDream {
    const newDream: WebDream = super.clone();
    newDream.clone = new WebDream().clone;
    return newDream;
  }
}
